/**
 * 敏感词管理配置文件
 * 用于配置表格列、表单字段、验证规则等，增强模块的扩展性
 */

// 表格列配置
export const tableColumns = [
  {
    prop: 'word_name',
    label: 'channel.wordName',
    width: 180,
    headerAlign: 'center',
    sortable: true,
    searchable: true
  },
  {
    prop: 'description',
    label: 'channel.description',
    headerAlign: 'center',
    searchable: true
  },
  {
    prop: 'sensitive_words',
    label: 'channel.sensitiveWords',
    headerAlign: 'center',
    searchable: true,
    customRender: true // 使用自定义渲染
  },
  {
    prop: 'created_at',
    label: 'channel.createTime',
    width: 180,
    headerAlign: 'center',
    sortable: true,
    formatter: 'datetime'
  },
  {
    prop: 'updated_at',
    label: 'channel.updateTime',
    width: 180,
    headerAlign: 'center',
    sortable: true,
    formatter: 'datetime'
  },
  {
    prop: 'operation',
    label: 'channel.operation',
    width: 200,
    fixed: 'right',
    headerAlign: 'center',
    customRender: true // 使用自定义渲染
  }
];

// 表单字段配置
export const formFields = [
  {
    field: 'word_name',
    label: 'channel.wordName',
    type: 'input',
    required: true,
    placeholder: 'channel.wordNamePlaceholder',
    rules: [
      { required: true, message: 'channel.wordNameRequired', trigger: 'blur' },
      { min: 1, max: 50, message: 'channel.wordNameLengthLimit', trigger: 'blur' }
    ]
  },
  {
    field: 'description',
    label: 'channel.description',
    type: 'textarea',
    required: false,
    placeholder: 'channel.descriptionPlaceholder',
    rows: 3,
    rules: [
      { max: 200, message: 'channel.descriptionLengthLimit', trigger: 'blur' }
    ]
  },
  {
    field: 'sensitive_words',
    label: 'channel.sensitiveWords',
    type: 'textarea',
    required: true,
    placeholder: 'channel.sensitiveWordsPlaceholder',
    rows: 4,
    tip: 'channel.sensitiveWordsTip',
    rules: [
      { required: true, message: 'channel.sensitiveWordsRequired', trigger: 'blur' },
      { min: 1, max: 1000, message: 'channel.sensitiveWordsLengthLimit', trigger: 'blur' }
    ]
  }
];

// 搜索字段配置
export const searchFields = [
  {
    field: 'keyword',
    label: 'channel.searchKeyword',
    type: 'input',
    placeholder: 'channel.searchKeywordPlaceholder'
  },
  {
    field: 'word_name',
    label: 'channel.wordName',
    type: 'input',
    placeholder: 'channel.wordNamePlaceholder'
  },
  {
    field: 'created_at',
    label: 'channel.createTime',
    type: 'daterange',
    placeholder: 'channel.createTimePlaceholder'
  }
];

// 批量操作配置
export const batchOperations = [
  {
    key: 'delete',
    label: 'channel.batchDelete',
    type: 'danger',
    icon: 'el-icon-delete',
    confirm: true,
    confirmMessage: 'channel.batchDeleteConfirm'
  },
  {
    key: 'export',
    label: 'channel.batchExport',
    type: 'primary',
    icon: 'el-icon-download'
  }
];

// 表格操作按钮配置
export const tableActions = [
  {
    key: 'edit',
    label: 'channel.edit',
    type: 'primary',
    size: 'mini',
    icon: 'el-icon-edit'
  },
  {
    key: 'delete',
    label: 'channel.delete',
    type: 'danger',
    size: 'mini',
    icon: 'el-icon-delete',
    confirm: true,
    confirmMessage: 'channel.deleteConfirm'
  }
];

// 分页配置
export const paginationConfig = {
  pageSize: 20,
  pageSizes: [10, 20, 50, 100],
  layout: 'total, sizes, prev, pager, next, jumper'
};

// 排序配置
export const sortConfig = {
  defaultSort: { prop: 'created_at', order: 'descending' },
  sortableColumns: ['word_name', 'created_at', 'updated_at']
};

// 导入导出配置
export const importExportConfig = {
  import: {
    enabled: true,
    acceptTypes: ['.xlsx', '.xls', '.csv'],
    maxSize: 10 * 1024 * 1024, // 10MB
    templateUrl: '/api/sensitive-words/template'
  },
  export: {
    enabled: true,
    formats: ['xlsx', 'csv'],
    filename: 'sensitive-words-{date}'
  }
};

// 敏感词检查配置
export const checkConfig = {
  enabled: true,
  realTime: false,
  highlight: true,
  replaceChar: '*'
};

// 权限配置
export const permissionConfig = {
  create: 'sensitive_words:create',
  read: 'sensitive_words:read',
  update: 'sensitive_words:update',
  delete: 'sensitive_words:delete',
  import: 'sensitive_words:import',
  export: 'sensitive_words:export'
};

// 默认值配置
export const defaultValues = {
  word_name: '',
  description: '',
  sensitive_words: '',
  main_id: '',
  user_id: ''
};

// 验证规则配置
export const validationRules = {
  word_name: {
    required: true,
    minLength: 1,
    maxLength: 50,
    pattern: /^[\u4e00-\u9fa5a-zA-Z0-9_\-\s]+$/
  },
  description: {
    required: false,
    maxLength: 200
  },
  sensitive_words: {
    required: true,
    minLength: 1,
    maxLength: 1000,
    pattern: /^[\u4e00-\u9fa5a-zA-Z0-9_\-\s,，]+$/
  }
};

// 错误消息配置
export const errorMessages = {
  networkError: 'channel.networkError',
  serverError: 'channel.serverError',
  validationError: 'channel.validationError',
  permissionDenied: 'channel.permissionDenied'
};

// 成功消息配置
export const successMessages = {
  create: 'channel.createSuccess',
  update: 'channel.updateSuccess',
  delete: 'channel.deleteSuccess',
  import: 'channel.importSuccess',
  export: 'channel.exportSuccess'
};

export default {
  tableColumns,
  formFields,
  searchFields,
  batchOperations,
  tableActions,
  paginationConfig,
  sortConfig,
  importExportConfig,
  checkConfig,
  permissionConfig,
  defaultValues,
  validationRules,
  errorMessages,
  successMessages
}; 